import { render, staticRenderFns } from "./burger.vue?vue&type=template&id=f4754364&scoped=true"
import script from "./burger.vue?vue&type=script&lang=js"
export * from "./burger.vue?vue&type=script&lang=js"
import style0 from "./burger.vue?vue&type=style&index=0&id=f4754364&prod&media=screen&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4754364",
  null
  
)

export default component.exports